import style from "./ViewEvent.module.css";
import classNames from "classnames/bind";
import { useContext, useEffect, useState } from "react";
import Filter from "../Filter/Filter";
import { LisencePlateManagerContext } from "../../../../contexts";
import { DepartmentList, Empty, ImageObject, Loading, Pagination, Table, Toast } from "../../../../components";
import { checkRoleSupAdmin, formatDB, formatDate, getTimeFormArrayToHour } from "../../../../utils";
import { identityHistoryFSR } from "../../../../services/api/identityHistoryFSR";
import { colum } from "./configTableViewEvent";
import { EyeIcon } from "../../../../components/Icons/Icons";
import PreviewImage from "../../../../components/DragUploadImage/PreviewImage";

const cx = classNames.bind(style);

const ViewEvent = () => {
    const { cameraCode, setTimeStart, setTimeEnd, dataStore, nameService, timeEnd, timeStart, params, isShow } = useContext(LisencePlateManagerContext)
    const [data, setData] = useState([]);

    const [filter, setFilter] = useState({
        nameEmployee: null,
        timeStart: new Date(),
        timeEnd: new Date(),
        page: 1,
        totalPage: 1,
        size: 10,
        organizationCode: checkRoleSupAdmin() ? null : sessionStorage?.getItem("company_code"),
        department: null
    })
    const [modalPreview, setModalPreview] = useState({
        show: false,
        image: null
    })
    const [loading, setLoading] = useState(true)
    const [dateHaveEvent, setDateHaveEvent] = useState([])

    useEffect(() => {
        let date = new Date();
        if (dataStore.pathNotification.time) {
            date = dataStore.pathNotification.time;
            const time = formatDate(date)
            setTimeStart(time);
            setTimeEnd(time);
        } else if (!timeEnd || !timeStart) {
            const time = formatDate(date)
            setTimeStart(time);
            setTimeEnd(time);
        }
    }, [dataStore.pathNotification.time])

    useEffect(() => {
        async function getListPlayBack() {
            if (cameraCode) {
                setData([])
                try {
                    const params = {
                        camera_code: cameraCode,
                        timeStart: formatDB(filter?.timeStart),
                        timeEnd: formatDB(filter?.timeEnd),
                        nameStaff: filter?.nameEmployee,
                        page: filter?.page,
                        limit: 10,
                        id_department: filter?.department
                    }
                    const res = await identityHistoryFSR.get(params);
                    if (res && res?.data) {
                        const listImage = res?.data?.map((item, index) => {
                            return {
                                stt: index + 1,
                                image: <ImageObject src={item?.image} />,
                                name_employee: item?.staffName,
                                department: item?.departmentName || '',
                                time_detect: item?.time ? getTimeFormArrayToHour(item?.time) : '',
                                organization_name: item?.organizationName || "",
                                action:
                                    <span onClick={() => handleShowItem(item)}>
                                        <EyeIcon color={'#0040ff'} />
                                    </span>
                            }
                        })
                        // setDayHl(day)
                        const total = Math.ceil(res.totalElement / 10);
                        setFilter(pre => ({ ...pre, totalPage: total }))
                        setData(listImage);
                        setDateHaveEvent(res?.dates || [])
                        setLoading(false)
                    }
                } catch (error) {
                    setLoading(false)
                    Toast.open("Lấy thông tin không thành công", "danger")
                }
            } else {
                setLoading(false)
            }

        }
        getListPlayBack();
    }, [cameraCode,
        filter?.page,
        params.id,
        filter?.nameEmployee,
        filter?.timeEnd,
        filter?.timeStart,
        filter?.organizationCode,
        filter?.department]);
    const handleRefresh = () => {
        setLoading(true)
    }

    const handleNextPage = () => {
        setFilter(pre => ({ ...pre, page: pre.page + 1 }))
        handleRefresh()
    }
    const handleChosetPage = (page) => {
        setFilter(pre => ({ ...pre, page: page }))
        handleRefresh()
    }
    const handlePrevPage = () => {
        setFilter(pre => ({ ...pre, page: pre.page - 1 }))
    }

    const handleChangeFilter = (key, value) => {
        if (key === "organizationCode") {
            setFilter(pre => ({ ...pre, [key]: value, page: 1, department: null }))
        } else {
            setFilter(pre => ({ ...pre, [key]: value, page: 1 }))
        }
        // handleRefresh()
    }

    const handleShowItem = (info) => {
        setModalPreview({
            show: !!info,
            image: info ? info?.image : null
        })
        // handleRefresh()
    }
    const handleClick = (e) => {
        setModalPreview({
            show: !!e,
            image: e ? e?.image?.props?.src : null
        })
    }
    return (
        <div className={cx("data")}>
            <div className={cx("filter")}>
                <Filter
                    value={filter}
                    onChange={handleChangeFilter}
                    dateHaveEvent={dateHaveEvent}
                />
            </div>
            <Table data={data} colum={colum} onClick={(e) => handleClick(e)} />
            {data?.length > 0 && !loading && <div className={cx('pagination')}>
                <Pagination
                    pages={filter.totalPage}
                    currentPage={filter.page}
                    onClick={handleChosetPage}
                    onNext={handleNextPage}
                    onPrevious={handlePrevPage}
                />
            </div>}
            {data?.length === 0 && !loading && cameraCode && <Empty title={"Không có dữ liệu phù hợp"} />}
            {!cameraCode && <div className={cx('no-camera')}>Chọn camera để xem sự kiện nhận dạng khuôn mặt!</div>}
            {modalPreview?.show && <PreviewImage
                previewImage={modalPreview?.image ? `${process.env.REACT_APP_FSR_IP}${modalPreview?.image}` : ''}
                previewOpen={modalPreview?.show}
                setPreviewImage={handleShowItem}
                setPreviewOpen={handleShowItem}
            />}
            {loading && <div className={cx('loading')}><Loading /></div>}
        </div>
    )
}

export default ViewEvent;